import React, { useCallback, useMemo } from 'react';
import NarrativeSettings from '../NarrativeSettings/NarrativeSettings';
import styles from './ManageTeamModalUser.module.scss';
import { useTranslation } from 'react-i18next';
import UserItem from '../ShareFolderModal/UserItem/UserItem';
import { useUserContext } from '../../context/UserContext';
import SelectClipsList from '../SelectClipsList/SelectClipsList';
import Icon from '../Icon/Icon';
import { CustomButton } from '../Button/Button';
import cx from 'classnames';
import InfoTooltip from 'engage/features/Home/components/InfoTooltip/InfoTooltip';

const ManageTeamModalUser = ({
  user,
  index,
  scenes,
  selected,
  data,
  selectUser,
  updateData,
  deleteUser,
}) => {
  const { t } = useTranslation();
  const { user: currentUser } = useUserContext();

  const handleReadChange = useCallback(value => {
    updateData(user.username, null, {
      read: value,
      update: !value && data.permissions.update ? false : data.permissions.update,
    });
  }, [updateData, user]);

  const handleUpdateChange = useCallback((value) => {
    updateData(user.username, null, {
      update: value,
      read: value && !data.permissions.update ? true : data.permissions.update,
    });
  }, [data, user]);

  const handleToggleClip = useCallback(
    clip => {
      updateData(user.username, clip.id);
    },
    [updateData, user]
  );

  const handleDeleteUser = userId => {
    deleteUser(userId);
  };

  const hasStoryAccess = useMemo(
    () =>
      data?.scenes?.length > 0 || Boolean(data?.permissions?.read) || Boolean(data?.permissions?.update),
    [data]);

  return (
    <div className={cx(styles.userContainer, { [styles.fade]: !hasStoryAccess })}>
      <div className={cx(styles.userItemHeader)}>
        <UserItem
          className={styles.customUserItem}
          user={user}
          existingUser={true}
          newUser={false}
          currentUser={currentUser}
          index={index}
          handleDelete={hasStoryAccess ? () => handleDeleteUser(user.username) : undefined}
        />
        {!hasStoryAccess && <InfoTooltip fixedPosition={true} text={t('storyboard.editor.lose_access', { name: user.name })} />}
        <CustomButton variant="link" className={styles.collapseBtn} onClick={() => selectUser(user.username)}>
          <span className={styles.clipsCount}>
            {data &&
              `${data?.scenes?.length ?? 0} ${data?.scenes?.length === 1 ? 'clip' : 'clips'
              } ${t('video.settings.selected')}`}
          </span>
          <Icon src="arrowDown" className={cx(styles.arrowIcon, { [styles.collapse]: selected })} />
        </CustomButton>
      </div>
      <div className={cx(styles.hide, { [styles.show]: selected })}>
        <NarrativeSettings
          className={styles.settingsWrapper}
          showHeader={false}
          username={user.username}
          seeStoryLine={data.permissions?.read}
          canEditClips={data.permissions?.update}
          handleStoryLine={handleReadChange}
          handleEditClips={handleUpdateChange}
        />
      </div>
      <SelectClipsList
        className={cx(styles.hide, { [styles.show]: selected })}
        showHeader={false}
        clips={scenes}
        selectedClips={data ? data.scenes : []}
        handleChooseClip={handleToggleClip}
      />
    </div>
  );
};

export default ManageTeamModalUser;
